import React from 'react'
import ContactPage from '../components/ContactPage';
import Navbar from '../components/Navbar'
import Footer from '../components/Footer';

function Contact() {
  return (
    <>
      <Navbar/>
      <ContactPage/>
      <Footer/>
    </>
  )
}

export default Contact